// extracted by mini-css-extract-plugin
export var accentColor = "#ff4832";
export var categoryBorderColor = "#0132b3";
export var disableRipple = "false";
export var fontFamily = "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif";
export var mainColor = "#0132b3";
export var mainContrast = "#fff";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#e5f0fa";
export var secondaryContrast = "rgba(0,0,0,.87)";